
import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest'

import {
  setInsightsCriteriaOrganisation,
  setInsightsCriteriaSubcategory,
  clearInsightsCriteria,
  setInsightsCriteriaType,
  setInsightsCriteriaBoundaries,
  setFromLastPage
} from '../store/actions/criteria-actions';

import { setSelectedReport } from '../store/actions/report-actions';
import { fetchBoundaries } from '../store/actions/location-actions';
import SVGIcon from '../components/SVGIcon';

import {
  pushRoute,
  isEmptyObject,
  escapeRegexCharacters
} from '../utilities/helpers';

const mapStateToProps = ({ home, insightsCriteria, reports, locations, brandAffinity, client }) => ({
  ...home,
  categories: reports.reports[reports.selectedReport.reportIndex] !== undefined &&
    Array.isArray(reports.reports[reports.selectedReport.reportIndex].subcategories)
    ? reports.reports[reports.selectedReport.reportIndex].subcategories
    : [],
  organisations: reports.reports[reports.selectedReport.reportIndex] !== undefined &&
    Array.isArray(reports.reports[reports.selectedReport.reportIndex].organisation)
    ? reports.reports[reports.selectedReport.reportIndex].organisation
    : [],
  ...insightsCriteria,
  selectedReport: reports.selectedReport,
  reportSelectOptions: reports.reportSelectOptions,
  organisationsAvailable:
    reports.reports[reports.selectedReport.reportIndex].organisationsAvailable,
  categoriesAvailable:
    reports.reports[reports.selectedReport.reportIndex].categoriesAvailable,
  geographyAvailable:
    reports.reports[reports.selectedReport.reportIndex].geographyAvailable,
  selectedReportPath: reports.selectedReport.value,
  ...locations,
  clientID: client.id,
  reportTiers: client.reports
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setInsightsCriteriaOrganisation,
      setInsightsCriteriaSubcategory,
      clearInsightsCriteria,
      setInsightsCriteriaBoundaries,
      setInsightsCriteriaType,
      setSelectedReport,
      fetchBoundaries,
      setFromLastPage,

    },
    dispatch
  );

const CriteriaModalGroupLabel = props => (
  <button
    className="CriteriaModalGroupLabel"
    onClick={() => console.log(props)}
  >
    <span className="CriteriaModalGroupLabel_inner">
      <span className="CriteriaModalGroupLabel_label">{props.label}</span>
      <span className="CriteriaModalGroupLabel_length">
        ({props.options.length > 1 ? (props.options.length - 1) : props.options.length})
      </span>
    </span>
  </button>
);

CriteriaModalGroupLabel.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.string.isRequired,
};


class CriteriaModal extends React.Component {

  state = {
    selectedBoundary: null,
    selectedReport: 0,
    value: '',
    geoObj: null,
    suggestions: []
  };

  componentDidMount() {
    if (!this.props.boundariesDataLoaded) {
      this.props.fetchBoundaries();
    }
  }

  componentWillMount() {
    this.props.clearInsightsCriteria();
  }

  handleSelectReport = report => {
    this.props.setInsightsCriteriaOrganisation(null);
    this.props.setInsightsCriteriaSubcategory(null);
    this.props.setSelectedReport(report);
    this.setState({ value: '', geoObj: null, selectedReport: report.reportIndex })
  };

  handelConfirmButton = () => {
    const { geoObj } = this.state;
    this.props.setInsightsCriteriaBoundaries({
      adm0:
        geoObj !== null && geoObj[0].level === 'adm0'
          ? geoObj
          : null,
      adm1:
        geoObj !== null && geoObj[0].level === 'adm1'
          ? geoObj
          : null,
      adm2:
        geoObj !== null && geoObj[0].level === 'adm2'
          ? geoObj
          : null,
      adm3:
        geoObj !== null && geoObj[0].level === 'adm3'
          ? geoObj
          : null,
      adm4:
        geoObj !== null && geoObj[0].level === 'adm4'
          ? geoObj
          : null,
      baseline: { label: `Country`, value: `country` },
      attribute:
        this.props.organisation !== null &&
          this.props.organisation.organisationType === 'digital'
          ? { label: `Mobile App`, value: `mobile-app` }
          : { label: `Footfall`, value: `footfall` },
    });

    if (this.props.reportId === this.props.selectedReport.name) {
      this.props.closeModal();
    } else {
      this.props.setFromLastPage(window.location.pathname);
      pushRoute(this.props.selectedReportPath);
    }
  }

  setGeographyOptionArray = (reports, selectedReportIndex) => {
    const showingTier = reports[selectedReportIndex].tiers;

    const tierArray = [{
      label: isEmptyObject(this.props.boundariesDictionary)
        ? 'New Zealand'
        : this.props.boundariesDictionary.country.name,
      value: 0,
      options: [{
        label: this.props.boundariesData[0] !== undefined &&
          this.props.boundariesData[0].options[0].label,
        level: 'adm0',
        value: this.props.boundariesData[0] !== undefined &&
          this.props.boundariesData[0].options[0].value,
      }]
    }];

    showingTier.forEach((item) => {
      switch (item) {
        case "district":

          tierArray.push({
            label: isEmptyObject(this.props.boundariesDictionary)
              ? 'District'
              : this.props.boundariesDictionary.district.name,
            value: 1,
            options: this.props.boundariesData[2] &&
              this.props.boundariesData[2].areas.map(item => {
                return {
                  label: `${item.name}, ${item.hierarchy.region}`,
                  level: 'adm2',
                  value: item.id,
                }
              })
          });
          let allDistrctOption = {
            label: `All Regional`,
            level: 'adm2',
            value: this.props.boundariesData[2].areas.map(item => item.id).join()
          };
          tierArray[tierArray.length -1].options.push(allDistrctOption);
          break;
        case "city":
          tierArray.push({
            label: isEmptyObject(this.props.boundariesDictionary)
              ? 'Major City'
              : this.props.boundariesDictionary.city.name,
            value: 2,
            options: this.props.boundariesData[3] &&
              this.props.boundariesData[3].areas.map(item => {
                return {
                  label: `${item.name}, ${item.hierarchy.region}`,
                  level: 'adm3',
                  value: item.id,
                }
              })
          });
          let allCityOption = {
            label: `All Metro`,
            level: 'adm3',
            value: this.props.boundariesData[3].areas.map(item => item.id).join()
          };

          tierArray[tierArray.length -1].options.push(allCityOption);
          break;
        case "locality":
          tierArray.push({
            label: isEmptyObject(this.props.boundariesDictionary)
              ? 'Suburb'
              : this.props.boundariesDictionary.locality.name,
            value: 3,
            options: this.props.boundariesData[4] &&
              this.props.boundariesData[4].areas.map(item => {
                return {
                  label: `${item.name}, ${item.hierarchy.place}`,
                  level: 'adm4',
                  value: item.id,
                }
              })
          });
          break;
        default:
          break;
      }
    })
    return tierArray;
  }

  getSuggestions = (value) => {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === '') {
      return [];
    }

    const regex = new RegExp('^' + escapedValue, 'i');

    return this.setGeographyOptionArray(this.props.reportTiers, this.state.selectedReport)
      .map(section => {
        return {
          label: section.label,
          options: section.options.filter(index => regex.test(index.label))
        };
      })
      .filter(section => section.options.length > 0);
  }

  getSuggestionValue = (suggestion) => {
    this.setState({
      geoObj: [suggestion],
    });
    return suggestion.label;
  }

  renderSuggestion = (suggestion) => <span>{suggestion.label}</span>

  renderSectionTitle = (section) => <strong>{section.label}</strong>

  getSectionSuggestions = (section) => section.options;


  onChange = (event, { newValue, method }) => {
    this.props.setInsightsCriteriaType('geography');
    method === 'type'
      ? this.setState({ value: newValue, geoObj: null })
      : this.setState({ value: newValue });
  };

  onBlur = (event) => {
    if (this.state.geoObj == null) {
      this.setState({
        value: ''
      });
    }
  }

  onSuggestionsFetchRequested = ({ value }) => this.setState({ suggestions: this.getSuggestions(value) });

  onSuggestionsClearRequested = () => this.setState({ suggestions: [] });

  render() {

    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: this.props.boundariesDataLoaded === false ? "Loading..." :  "Type a geographical area",
      value,
      onChange: this.onChange,
      onBlur: this.onBlur,
      disabled: (this.props.organisation !== null && this.props.insightType === 'organisation') ||
        this.props.boundariesDataLoaded === false
    };

    return (
      <div className="CriteriaModal_inner">
        {this.props.closeModal && (
          <button
            className="CriteriaModal_close-button"
            type="button"
            onClick={this.props.closeModal}
          >
            <SVGIcon icon="cancel" />
            <span className="screen-reader">Close</span>
          </button>
        )}
        <SVGIcon icon="pin-search" />
        <h2 className="CriteriaModal_title">Select insight criteria</h2>
        {this.props.reportSelectOptions.length > 1 && (
          <React.Fragment>
            <label
              className="CriteriaModal_label"
              htmlFor="criteria-modal-select-report"
            >
              Select report:
            </label>
            <div className="CriteriaModal_top-row">
              <Select
                inputId="criteria-modal-select-report"
                className="CriteriaModal_report-input"
                classNamePrefix="CriteriaModal_report-input_"
                isSearchable
                name="report"
                options={this.props.reportSelectOptions}
                onChange={this.handleSelectReport}
                value={this.props.selectedReport}
              />
            </div>
          </React.Fragment>
        )}
        {this.props.organisationsAvailable && (
          <React.Fragment>
            <label
              className="CriteriaModal_label"
              htmlFor="criteria-modal-select-report"
            >
              Select organisation:
            </label>
            <Select
              inputId="criteria-modal-select-organisation"
              className="CriteriaModal_search-organisation-input"
              classNamePrefix="CriteriaModal_search-organisation-input_"
              placeholder="Search organisation"
              isDisabled={
                (this.props.subcategory !== null && this.props.insightType === 'category') ||
                (this.state.value !== '' && this.props.insightType === 'geography')
              }
              isClearable
              isRtl={false}
              isSearchable
              name="organisation"
              options={this.props.organisations}
              onChange={event =>
                this.props.setInsightsCriteriaOrganisation(
                  event,
                  event !== null ? event.subcategory : null
                )
              }
              value={this.props.organisation}
            />
          </React.Fragment>
        )}
        {this.props.categoriesAvailable && (
          <React.Fragment>
            <label
              className="CriteriaModal_label"
              htmlFor="criteria-modal-select-subcategories"
            >
              Or explore our categories
            </label>
            <Select
              inputId="criteria-modal-select-subcategories"
              className="CriteriaModal_subcategories-input"
              classNamePrefix="CriteriaModal_subcategories-input_"
              placeholder="Make a category selection"
              isDisabled={
                this.props.organisation !== null &&
                this.props.insightType === 'organisation'
              }
              isClearable
              isRtl={false}
              isSearchable
              name="organisation"
              formatGroupLabel={CriteriaModalGroupLabel}
              options={this.props.categories}
              onChange={e => this.props.setInsightsCriteriaSubcategory(e)}
              value={this.props.subcategory}
            />
          </React.Fragment>
        )}

        {this.props.geographyAvailable && (
          <React.Fragment>
            <label
              className="CriteriaModal_label"
              htmlFor="criteria-modal-select-subcategories"
            >
              Select a geographical area
            </label>
            <Autosuggest
              multiSection={true}
              suggestions={suggestions}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
              getSuggestionValue={this.getSuggestionValue}
              renderSuggestion={this.renderSuggestion}
              renderSectionTitle={this.renderSectionTitle}
              getSectionSuggestions={this.getSectionSuggestions}
              focusInputOnSuggestionClick={true}
              inputProps={inputProps}
            />

          </React.Fragment>
        )}


        <div className="CriteriaModal_bottom-row">
          <span className="CriteriaModal_bottom-row_left" />
          <div className="CriteriaModal_bottom-row_right">
            <button
              onClick={this.handelConfirmButton}
              className="CriteriaModal_search-button"
              type="button"
              disabled={
                (this.state.value === '' && this.props.subcategory === null)
                || !this.props.boundariesDataLoaded
              }
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    );
  }
}

CriteriaModal.propTypes = {
  closeModal: PropTypes.func,
  clearInsightsCriteria: PropTypes.func.isRequired,
  setInsightsCriteriaOrganisation: PropTypes.func.isRequired,
  setInsightsCriteriaSubcategory: PropTypes.func.isRequired,
  organisations: PropTypes.arrayOf(PropTypes.object).isRequired,
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  reportSelectOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedReportPath: PropTypes.string.isRequired,
  selectedReport: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    reportIndex: PropTypes.number,
  }).isRequired,
  organisation: PropTypes.object, // eslint-disable-line
  subcategory: PropTypes.object, // eslint-disable-line
  insightType: PropTypes.string,
  organisationsAvailable: PropTypes.bool.isRequired,
  categoriesAvailable: PropTypes.bool.isRequired,
  setSelectedReport: PropTypes.func.isRequired,
  reportId: PropTypes.string,
};

CriteriaModal.defaultProps = {
  organisation: null,
  subcategory: null,
  insightType: null,
  closeModal: null,
  reportId: null,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CriteriaModal);
